import { BiVisualizationBody } from '@euler/app/components/message/widgets/bi-visualization/BiVisualizationBody';
import { Typography } from '@euler/app/components/typography';
import {
  CardLoading,
  CardNotice,
} from '@euler/app/flows/ai-suite/components/ChatCard';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiPalette, BiVizSpec } from '@euler/model/bi/viz';
import { memo } from 'react';
import { View } from 'react-native';
import { BiPreviewState } from './functions/useBiPreview';

/** The card as it will look, from the spec run live. */
export const EditorPreview = memo(
  ({
    problem,
    preview,
    viz,
    palette,
  }: {
    /** Why there is nothing to run yet. */
    problem: string | null;
    preview: BiPreviewState;
    viz: BiVizSpec | null;
    palette?: BiPalette;
  }) => {
    const { rpx } = useResponsiveContext();
    let body = null;
    if (problem) body = <CardNotice text={problem} />;
    else if (preview.kind === 'failed')
      body = <CardNotice tone="danger" text={preview.message} />;
    else if (preview.kind === 'ready' && viz)
      body = (
        <BiVisualizationBody
          viz={viz}
          result={{ current: preview.result }}
          palette={palette}
        />
      );
    else body = <CardLoading label="正在预览…" />;
    return (
      <View
        style={{
          gap: rpx(8),
          padding: rpx(12),
          borderRadius: rpx(12),
          borderWidth: 1,
          borderColor: aiColors.border,
          backgroundColor: aiColors.background,
          minHeight: rpx(120),
        }}
      >
        <Typography.Text medium size={rpx(12)} color={aiColors.mutedForeground}>
          预览
        </Typography.Text>
        {body}
      </View>
    );
  },
);
